
import {useMemo} from 'react';

export const useShuffle = (trues: number, total: number): boolean[] => (
	useMemo(() => {
		const output: boolean[] = [];
		for (let i = 0; i < total; i++) {
			output.push(i < trues);
		}

		output.sort(() => 0.5 - Math.random());
		return output;
	}, [trues, total])
);
